// フォームの動作保管
jQuery(function($) {
  // リセット
  if ($('.js-formclear').length) {
    // console.log('.js-formclear is exist');
    $('.js-formclear').bind('click', function() {
      $(this.form).find("textarea, :text, input[type=email], select").val("").end().find(":checked").prop("checked", false);
      if ($(this).attr('data-btn-type') === 'search-change') {
        $('.modaal-wrapper').animate({
          scrollTop: '0px'
        }, 800, 'swing');
      }
    });
  }
  // キーボード
  if ($('.js-form').length) {
    // console.log('.js-form is exist');
    $('input').keypress(function(e) {
      // console.log('keypress');
      if (e.keyCode === 13) {
        // e.preventDefault();
        // 現在フォーカスしている入力欄からフォーカスを外すことで、キーボードを強制的に閉じる
        document.activeElement.blur();
        $('input').blur();
        return false;
      }
    });
  }
});
